import { Transition } from "@headlessui/react";

const Overlay = ({ overlayEnabled }) => {
  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Transition
      show={!!overlayEnabled}
      appear
      enter="transition-opacity duration-[400ms] ease-out"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-[400ms] ease-in"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        aria-hidden="true"
        className="fixed inset-0 bg-black/10 pointer-events-auto"
        style={{ zIndex: 9998 }}
        onClick={preventDefault}
        onMouseDown={preventDefault}
        onPointerDown={preventDefault}
        onTouchStart={preventDefault}
        onContextMenu={preventDefault}
      />
    </Transition>
  );
};

export default Overlay;
